import type { StaffCatalogSearchEmbeddingState } from "@lafayette/schemas";

import { StatusBadge, type StatusTone } from "../../ui/status-badge";
import { embeddingStateLabels } from "./labels";

const tones: Readonly<Record<StaffCatalogSearchEmbeddingState, StatusTone>> = {
  NONE: "neutral",
  PENDING: "warning",
  READY: "success",
  STALE: "warning",
  FAILED: "danger",
};

/** An embedding state as a glyph and a word. The glyph is decoration: the word carries the meaning. The `title` is a fixed help sentence. */
export function EmbeddingBadge({ state }: Readonly<{ state: StaffCatalogSearchEmbeddingState }>) {
  const entry = embeddingStateLabels[state];
  return (
    <span data-state={state} title={entry.help} className="inline-flex">
      <StatusBadge tone={tones[state]} glyph={entry.glyph}>
        {entry.label}
      </StatusBadge>
    </span>
  );
}

/** A value that can be missing: a dash for the eye and a word for a screen reader. */
export function Missing({ word }: Readonly<{ word: string }>) {
  return (
    <>
      <span aria-hidden="true">—</span>
      <span className="sr-only">{word}</span>
    </>
  );
}
